import React, { useState } from 'react';

import { useHistory } from 'react-router-dom';
import { DeleteAllModal } from '../DeleteAllModal';
import { ApRadio, ApButtonDanger } from '@alixpartners/ui-components';
import {
  ActionsWrapper,
  RadioWrapper,
  RightSection,
} from './SpendTypeSwitch.styles';
import { SpendTypeEnum } from 'components/Classification';
import { ROOT_ROUTE } from 'views/ClassificationRules/routes';
import { deleteAllClassificationRules } from 'utils/api';
import { ApiContext } from 'context/ApiContext';
import { PERMISSIONS } from 'utils/constants';

export const LABELS = {
  [SpendTypeEnum.THIRD_PARTY]: 'Third party',
  [SpendTypeEnum.PERSONNEL]: 'Personnel',
};

interface IProps {
  spendType: SpendTypeEnum;
  permissions: string[];
}

export const SpendTypeSwitch: React.FC<IProps> = ({
  spendType,
  permissions,
}) => {
  const history = useHistory();
  const [isModalOpen, setModalOpen] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const hasWritePermission = permissions.includes(
    PERMISSIONS.SETTINGS_CLASSIFICATION_WRITE
  );

  const changeSpendType = (e: React.BaseSyntheticEvent) => {
    const value = e.target.value;

    history.push(`${ROOT_ROUTE}/${value}`);
  };

  const showDeleteModal = () => {
    setModalOpen(true);
  };

  const closeDeleteModal = () => {
    setModalOpen(false);
  };

  const deleteAllRules = () => {
    setLoading(true);

    deleteAllClassificationRules(spendType).then(() => {
      setLoading(false);
      closeDeleteModal();

      history.push('/');
      history.replace(`${ROOT_ROUTE}/${spendType}`);
    });
  };

  return (
    <ActionsWrapper>
      <RadioWrapper>
        <ApRadio
          id={SpendTypeEnum.THIRD_PARTY}
          name="spend-type-rules"
          value={SpendTypeEnum.THIRD_PARTY}
          checked={spendType === SpendTypeEnum.THIRD_PARTY}
          onChange={changeSpendType}
        >
          {LABELS[SpendTypeEnum.THIRD_PARTY]} rules
        </ApRadio>
      </RadioWrapper>
      <RadioWrapper>
        <ApRadio
          id={SpendTypeEnum.PERSONNEL}
          name="spend-type-rules"
          value={SpendTypeEnum.PERSONNEL}
          checked={spendType === SpendTypeEnum.PERSONNEL}
          onChange={changeSpendType}
        >
          {LABELS[SpendTypeEnum.PERSONNEL]} rules
        </ApRadio>
      </RadioWrapper>
      {hasWritePermission && (
        <RightSection>
          <ApButtonDanger
            iconName="delete_outline"
            onClick={showDeleteModal}
            disabled={isLoading}
          >
            Delete all {LABELS[spendType]} rules
          </ApButtonDanger>
        </RightSection>
      )}
      {isModalOpen && (
        <DeleteAllModal
          isOpen={isModalOpen}
          onClose={closeDeleteModal}
          onDelete={deleteAllRules}
          spendType={spendType}
          isDisabled={isLoading}
        />
      )}
    </ActionsWrapper>
  );
};

export default (props: any) => (
  <ApiContext.Consumer>
    {({ permissions }) => (
      <SpendTypeSwitch {...props} permissions={permissions} />
    )}
  </ApiContext.Consumer>
);
